import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import ResourceSelect from "../../../../../../components/Inputs/ResourceSelect";
import {
	getSettingsOrgResourceSearchFilters,
	renderSettingsResourceLabel,
} from "../../../../../../utils/helpers/settings";
import { useGroups } from "../../../../../Settings/General/OrganisationLevelGroups/context";
import { useOrgSettingsResourceLabel } from "../../../../../../utils/hooks/useOrgSettingsResourceLabel";

export const useGroupsFilters = () => {
	const { t } = useTranslation();
	const { groups } = useGroups();
	const renderOrgLevelResourceLabel = useOrgSettingsResourceLabel();

	return useMemo(() => {
		return groups.map((group) => ({
			name: group?.level?.replace("_", ""),
			label: t("resource-worked", { resource: renderSettingsResourceLabel(group) }),
			type: "resource-select",
			component: (
				<ResourceSelect
					mode="multiple"
					resourcePath={`/${group?.id}/org-levels`}
					renderLabel={renderOrgLevelResourceLabel}
					valuePropName="id"
					getSearchFilters={getSettingsOrgResourceSearchFilters}
					hasSearch
				/>
			),
		}));
	}, [groups, renderOrgLevelResourceLabel, t]);
};
